import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/Index.css';
import NavBar from './components/navBar'
import Hero from './components/hero'
import Footer from './components/footer'
import Chateau from './components/chateau'
import Wine from './components/wine'
import Visit from './components/visit'
import Contacts from './components/contacts'
import PhotoGallery from './components/gallery'
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom"


export default class App extends Component {
  state = {
    lang: 'en',
    nav: 'home',
  }
  setLang =(loc)=>{
    this.setState({lang: loc})
  }
  setNav =(section)=>{
    this.setState({nav: section})
  }

  render() {
    return (
      <Router>
        <NavBar lang={this.state.lang} nav={this.state.nav}/>
        <Switch>
          <Route exact path="/">
            <main>
              <Hero lang={this.state.lang} setLang={(loc)=>{this.setLang(loc)}} nav={this.state.nav} setNav={(section)=>{this.setNav(section)}}/>
              <Chateau lang={this.state.lang} nav={this.state.nav} setNav={(section)=>{this.setNav(section)}}/>
              <Wine lang={this.state.lang} nav={this.state.nav} setNav={(section)=>{this.setNav(section)}}/>
              <Visit lang={this.state.lang} nav={this.state.nav} setNav={(section)=>{this.setNav(section)}}/>
              <PhotoGallery lang={this.state.lang} nav={this.state.nav} setNav={(section)=>{this.setNav(section)}}/>
              <Contacts lang={this.state.lang} nav={this.state.nav} setNav={(section)=>{this.setNav(section)}}/>
            </main>
          </Route>
        </Switch>
        <Footer lang={this.state.lang}/>
      </Router>
    );
  }
}
